import Entity from './entity'

export default class PurchaseOrder extends Entity<number>{
    orderNo : number;
    code : string;
    poDate : Date;
    status : string;
    note : string;
    contactName : string;
    contactPhone : string;
    clientCode : string;
    warehouseCode : string;
    shippingDate : Date;
    assetTypeCode : string;
    conditionTypeCode : string;
    finishedDate : string;
    srcClientBranchId : number;
    externalCode : string;
    parentId : number;
    type : string;
    inputChannelCode : string;
    creationTime : Date;
    creatorUserId : number;
    creatorUserName : string;
    inputChannelName : string;
    srcClientBranchName : string;
    conditionTypeName : string;
    statusName : string;
    assetTypeName : string;
    poTypeName : string;
    clientName:string;
    warehouseName:string;
    declareOverShort :boolean;
    customerId: number;
    customerCode:string;
    customerName:string;
    supplierName:string;
    returnSoId:number;
    returnSoCode :string;
    canceledNote:string;
    canceledDate :Date;
    canceledByName :string;
    toReqId:number;
    containerNumber:string;
    invoiceNumber:string;
    invoiceDate:Date;
    productType:string;
    productTypeName:string;
    externalSoId:number;
    externalSoCode :string;
}